// Browser polyfills that must run before any app module (aws-sdk included)
// evaluates — keep this the first import of entry.client.tsx.
//
// Real Buffer for the browser: aws-sdk >= 3.973's CBOR/JSON codec-v2 modules
// call Buffer.allocUnsafe / Buffer.from(...).toString("base64") at init, which
// the old hand-rolled Uint8Array stub in index.html cannot satisfy. The
// `buffer` package is a full implementation. In Node/SSR the native global is
// already defined and is left untouched.
import { Buffer } from "buffer";

if (typeof globalThis.Buffer === "undefined") {
  (globalThis as { Buffer: typeof Buffer }).Buffer = Buffer;
}
